<template>
  <nav id="nav" class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header float-right">
<!--        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">-->
<!--          <span class="sr-substring">Toggle navigation</span>-->
<!--          <span class="icon-bar bar1"></span>-->
<!-- https://limsabc.tpondemand.com/RestUI/Board.aspx#page=profile&boardPopup=request/21817/silent         <span class="icon-bar bar2"></span>-->
<!--          <span class="icon-bar bar3"></span>-->
<!--        </button>-->
        <language-button style="float: left;"></language-button>

        <router-link to="/" class="navbar-brand brand-padding">
            <img v-if="checkIfLogoIsBase64()" id="client-logo" v-bind:src="'data:image/jpeg;base64,'+logo" />
            <img v-else id="client-logo" :src="logo" alt="">
        </router-link>
      </div>
      <div class="collapse navbar-collapse"></div>
    </div>
  </nav>
</template>
<script>
  import LanguageButton from '../Views/LanguageButton'
  export default {
    data () {
      return {
        activeNotifications: false
      }
    },
    computed: {
      logo () {
        return this.$store.state.logo
      }
    },
    components: {
      LanguageButton
    },
    methods: {
      checkIfLogoIsBase64 () {
        return this.logo.length % 4 === 0 && /^[A-Za-z0-9+/]+[=]{0,3}$/.test(this.logo)
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }

</script>
<style scoped>
  .float-right{
    float: right !important;
  }

  .brand-padding{
    margin: 2px 0 0 0 !important;
  }

  #client-logo{
    max-width: 200px;
    max-height: 40px;
  }

  >>> .language{
    margin: 15px 10px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue